/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import * as Chart from 'chart.js';

const TaxComplianceChart = ({ 
  data, 
  width = '100%', 
  height = 200
}) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = chartRef.current.getContext('2d');
    
    Chart.Chart.register(
      Chart.CategoryScale,
      Chart.LinearScale,
      Chart.BarElement,
      Chart.Title,
      Chart.Tooltip,
      Chart.Legend
    );

    // Transform data to show only compliant (green) and non-compliant (orange) bars
    const transformedData = data.labels.map((label, index) => {
      const compliantValue = data.datasets[0].data[index];
      const nonCompliantValue = data.datasets[1].data[index];
      
      if (compliantValue === 1) {
        return { label, value: 1, color: '#a8d5a8', status: 'compliant' };
      } else if (nonCompliantValue === 1) {
        return { label, value: 1, color: '#ffb380', status: 'non-compliant' };
      } else {
        return { label, value: 0.1, color: '#e5e5e5', status: 'unknown' };
      }
    });

    const chartData = {
      labels: transformedData.map(item => item.label),
      datasets: [{
        data: transformedData.map(item => item.value),
        backgroundColor: transformedData.map(item => item.color),
        borderColor: transformedData.map(item => item.color),
        borderWidth: 1,
        barThickness: 40,
      }]
    };

    const config = {
      type: 'bar',
      data: chartData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              generateLabels: function(chart) {
                return [
                  {
                    text: 'Compliant',
                    fillStyle: '#a8d5a8',
                    strokeStyle: '#a8d5a8',
                    lineWidth: 0,
                    pointStyle: 'rect'
                  },
                  {
                    text: 'Non Compliant',
                    fillStyle: '#ffb380',
                    strokeStyle: '#ffb380',
                    lineWidth: 0,
                    pointStyle: 'rect'
                  }
                ];
              },
              usePointStyle: true,
              pointStyle: 'rect',
              padding: 15,
              font: {
                size: 11
              }
            }
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                const item = transformedData[context.dataIndex];
                return item.status === 'compliant' ? 'Compliant' : 'Non Compliant';
              }
            }
          }
        },
        scales: {
          x: {
            display: true,
            grid: {
              display: false
            },
            ticks: {
              font: {
                size: 10
              },
              maxRotation: 40,
              minRotation: 10,
              color: '#333',
              maxTicksLimit: 20
            }
          },
          y: {
            display: false,
            beginAtZero: true,
            max: 1.5,
            grid: {
              display: false
            },
            ticks: {
              display: false
            }
          }
        },
        layout: {
          padding: {
            top: 40,
            bottom: 20,
            left: 20,
            right: 20
          }
        }
      },
      // plugins: [{
      //   id: 'dataLabels',
      //   afterDatasetsDraw: (chart) => {
      //     const ctx = chart.ctx;
      //     const meta = chart.getDatasetMeta(0);
      //     meta.data.forEach((bar, index) => {
      //       const data = transformedData[index];
      //       ctx.fillStyle = '#333';
      //       ctx.font = 'bold 16px Arial';
      //       ctx.textAlign = 'center';
      //       ctx.textBaseline = 'middle';
            
      //       if (data.value === 1) {
      //         ctx.fillText('1', bar.x, bar.y - (bar.height / 2) + 10);
      //       } else {
      //         ctx.fillText('0', bar.x, bar.y - 10);
      //       }
      //     });
      //   }
      // }]
    };

    chartInstance.current = new Chart.Chart(ctx, config);

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data]);

  return (
    <div style={{ 
      width, 
      height, 
      position: 'relative', 
      border: '1px solid #ccc', 
      backgroundColor: 'white',
      padding: '10px'
    }}>
      <canvas ref={chartRef} />
    </div>
  );
};

export default TaxComplianceChart;
